import jscookie from 'js-cookie'
import { AUTH_COOKIE } from '../modules/user'
import { AUTH_API_COOKIE } from '../modules/user'
import store from '../../store'
import { loadModules } from 'esri-loader';
import hexRgb from'hex-rgb'

const state = {
	colorDomain: 		 null,			// 'room or employee or others'
	colorAttribute: 	 'useName',		// 'useCode or title'
	legend: [], 						// [{ label, color, area, rooms }] 
	floorRooms: [],
	colors: [],
	useDeptColors: false,
	hatchClassOn: false,
}

const mutations = {	
	setColorDomain(state, payload) {
		state.colorDomain = payload;
	},

	setColorAttribute(state, payload) {
		state.colorAttribute = payload;
	},

	setUseDeptColors(state, payload) {
		state.useDeptColors = payload
	},

	setHatchClassOn(state, payload) {
		state.hatchClassOn = payload
	},

	setLegend(state, payload) {
		state.legend = payload
	},

	// Used to add manage user defined custom colors
	updateColors(state, payload) {
    
	    if (payload == "Clear") { 
	      	state.colors = []
	      	return
	    }

	    let colors = state.colors.slice(0)
	    let foundRow = colors.findIndex(item => item.legendLabel == payload.legendLabel )
	    
	    // If this label is found in colors, delete it, or skip it if we are only clearing defaults
	    if (foundRow != -1) {
	      
	      	if (!payload.skipExisting) { 
	          	console.log("Deleting Color: ", colors[foundRow].color, colors[foundRow].legendLabel)
	          	colors.splice(foundRow, 1) 
	      	}

	      	// return instead of ADDING this existing one
	      	if (payload.skipExisting) {
	          	return	          
	      	}

	    }

	    // Add to user defined colors (state.colors)
	    if (payload.color) {
	      	colors.push(payload)
	    } 

	    // Update State
	    state.colors = colors
  	},

  	
}

const actions = {

	// This action called anytime a re-coloring is needed.  Its watched in esri-map on buildingRooms change
	// It is called directly on coloring tab functions.
 	// This single action calls everything necessary to color the current building floor using state 'domain' and 'attribute'.
 	// This is the array // [{ label, color, area, rooms }] It is built in steps.  
 	// 1st just the labels are pushed into the array
	buildColorizedLegendArray ({state, rootState}) {
		rootState.mapFunctions.clearGraphics('colorlayer')

		if (state.colorDomain && rootState.space.buildingRooms.length > 0) { 
			if (state.colorDomain == 'room' && state.colorAttribute == 'loaned') {
				//console.log("Domain: Room")
			 	store.dispatch('buildColorizedLegendArraybyLoaned')
			 	store.dispatch('processLegend')
				return
			}

			if (state.colorAttribute == 'position') {
				console.log("Color by Position Description")
				store.dispatch('buildColorizedLegendArraybyPosition')
			 	//store.dispatch('processLegend')
				return
			}

			if (state.colorAttribute == 'deptExploded') {
				//console.log("Color by Dept Share Exploded")
				store.dispatch('buildColorizedLegendArraybyDeptExplodeShare')
			 	//store.dispatch('processLegend')
				return
			}

			if (state.colorAttribute == 'deptShareBlend') {
				//console.log("Color by Dept Share Blended")
				store.dispatch('buildColorizedLegendArraybyDeptShareBlend')
			 	//store.dispatch('processLegend')
				return
			}

/*			if (state.colorAttribute == 'utilization') {
				console.log("Color by Room Utilization")
				store.dispatch('buildColorizedLegendArraybyRoomAttribute')
				//store.dispatch('buildColorizedLegendArraybyUtilization')
			 	//store.dispatch('processLegend')
				return
			}*/

			if (state.colorDomain == 'room') {
				//console.log("Domain: Room")
			 	store.dispatch('buildColorizedLegendArraybyRoomAttribute')
			 	store.dispatch('processLegend')
				return
			}
			
			if (state.colorDomain == 'employee' ) {
				console.log("Domain: Employee")
				store.dispatch('buildColorizedLegendArraybyRoomAttribute')
			 	store.dispatch('processLegend')
				return
			}

			
		}
	},

	// Use state variables colorAttribute and colorAttributeValue, buildingRooms, currentfloor to build array
	buildColorizedLegendArraybyRoomAttribute ({state, rootState}) {		
		
		// Filter state.buildingRooms (preloaded rooms for current building) to current floor.
		state.floorRooms = rootState.space.buildingRooms.filter((room) => room.floor === rootState.ui.currentFloor)
		
		// For these rooms, determine unique Legend Items / values for chosen attribute. 
		state.legend = []
		state.floorRooms.forEach((room) => {
			if (!state.legend.find((legendItem) => legendItem.label == room[state.colorAttribute] )) {  // Enforce Unique
			    state.legend.push({ 'label': room[state.colorAttribute] })
			}
		})
		//console.log(state.legend)
	},

	buildColorizedLegendArraybyLoaned ({state, rootState}) {		
		
		// Filter state.buildingRooms (preloaded rooms for current building) to current floor.
		state.floorRooms = rootState.space.buildingRooms.filter((room) => room.floor === rootState.ui.currentFloor)
		
		// For these rooms, determine unique Legend Items / values for chosen attribute. 
		state.legend = []
		state.floorRooms.forEach((room) => {
			// Add deptNames for these rooms
			if (!state.legend.find((legendItem) => legendItem.label == room.deptName )) {  // Enforce Unique
			    state.legend.push({ 'label': room.deptName })
			}
			// Add userDeptNames for these rooms			
			if (room.userDeptName && !state.legend.find((legendItem) => legendItem.label == room.userDeptName )) {  // Enforce Unique
			    console.log("Added userDept", room.userDeptName)
			    state.legend.push({ 'label': room.userDeptName })
			}
		})
		//console.log(state.legend)
	},

	// This code can be used to colorize by an Amenity that has multiple values
	// This is not used right now because interested columns were moved to the room table
	/*async buildColorizedLegendArraybyUtilization ({dispatch, commit, state, rootState}) {
		
		// Get amenity key for Room Condition.  Needed for Search API
		let listOfLists = await dispatch('fetchAmenitiesListOfLists')
		let list = listOfLists.find((list) => list.listname == "Research Space Survey")
		let listDefinition = await dispatch('fetchAmenitiesList', { key: list.key })
		//console.log(listDefinition.list)
		let conditionAmenity = listDefinition.list.find((amenity) => amenity.label == "Room Utilization")
		let myKey = conditionAmenity.key

		//Build Legend.  Using static since not expected to change.
		state.legend = []
		state.legend.push({ 'label': 'High'})
		state.legend.push({ 'label': 'Low'})
		state.legend.push({ 'label': 'Vacant'})

		state.legend[0].rooms = await getUtilizationRooms("High")
		state.legend[1].rooms = await getUtilizationRooms("Low")
		state.legend[2].rooms = await getUtilizationRooms("Vacant")

		state.legend[0].color = 'rgb(0 ,128 ,0)'
		state.legend[1].color = 'rgb(255 ,69 , 0)'
		state.legend[2].color = 'rgb(255 ,25 ,25)'

		state.legend.forEach((legendItem) => {
			// Summarize Area for each legend item
			let area = 0
			legendItem.rooms.forEach((room) => { area += room.area })
			legendItem.area = area
		})

		// Sort Array on Area
		state.legend.sort(function(a,b) {return b.area - a.area});		
			
		// Set Colors
		//dispatch('setLegendItemColor')

		// Color Rooms
        dispatch('colorRooms')

		// Helper function to grab matching rooms out of Amenity Search API
		async function getUtilizationRooms(searchValue) {
			return new Promise((resolve, reject) => {
			let search = [{ 	'amenitykey': 	myKey,
								'label':  		"Room Utilization",
								'operand':   	"=", 
								'dataType':		"Allowed Values",
								'value': 		searchValue
			}]

			let searchResults = null
			dispatch('fetchSearchRoomAmenities', search).then((data) => {
				//console.log("searchResults: ", data)
				searchResults = data
				//Make a room array from search results
				let rooms = []		
				searchResults.sites.forEach((site) => {
					site.buildings.forEach((building) => {
						building.floors.forEach((floor) => {
							floor.rooms.forEach((room) => {						
								rooms.push(room)
							})
						})
					})
				})

				// Filter to current building/floor
				rooms = rooms.filter((room) => room.bldgAlpha == rootState.space.selectedBuilding.bldgAlpha &&
											   room.floor == rootState.ui.currentFloor)
				//console.log(searchValue, rooms)
				resolve(rooms)
			})
			

			

			
			})
		}
	},*/

	async buildColorizedLegendArraybyDeptShareBlend ({dispatch, state, rootState}) {
		// This particular one needs the full room return to get down to employees
		// Also this function combines the processLegend functions which I think is a better pattern
		let payload = { bldgAlpha: rootState.space.selectedBuilding.bldgAlpha, floor: rootState.ui.currentFloor }
		
		// Filter state.buildingRooms (preloaded rooms for current building) to current floor.
		state.floorRooms = rootState.space.buildingRooms.filter((room) => room.floor === rootState.ui.currentFloor)
		
		console.log("Rooms: ", state.floorRooms)
		// For these rooms, determine unique Legend Items / values for chosen attribute. 
		state.legend = []
		state.floorRooms.forEach((room) => {
			room.departments.forEach((dept) => { 
				// Add Label to the label array
				if (!state.legend.find((legendItem) => legendItem.label == dept.deptName )) {  // Enforce Unique
					state.legend.push({ 'label': dept.deptName })
				}
			})
		})

		// For each legend item, find matching rooms in floorRooms, summarize area, push into colorizeArray
		state.legend.forEach((legendItem) => {			
			// Find rooms that match each legenditem, put in rooms array
			let rooms = []

			state.floorRooms.forEach((room) => { 
			room.departments.forEach((dept) => {
				if (dept.deptName == legendItem.label) { rooms.push(room) }}) // Add matching room to array
			})
			
			legendItem.rooms = rooms

			// Summarize Area for each legend item
			let area = 0			
			legendItem.rooms.forEach((room) => { area += room.area })
			legendItem.area = area
		})

		// Sort Array on Area
		state.legend.sort(function(a,b) {return b.area - a.area});		
			
		// Set Colors
		dispatch('setLegendItemColor')

		// Color Rooms
        dispatch('colorRooms')
	},

	async buildColorizedLegendArraybyDeptExplodeShare ({dispatch, state, rootState}) {
		// This particular one needs the full room return to get down to employees
		// Also this function combines the processLegend functions which I think is a better pattern
		let payload = { bldgAlpha: rootState.space.selectedBuilding.bldgAlpha, floor: rootState.ui.currentFloor }
		// Filter state.buildingRooms (preloaded rooms for current building) to current floor.
		state.floorRooms = rootState.space.buildingRooms.filter((room) => room.floor === rootState.ui.currentFloor)
		console.log("Rooms: ", state.floorRooms)
		// For these rooms, determine unique Legend Items / values for chosen attribute. 
		state.legend = []
		state.floorRooms.forEach((room) => {
			let label = ""			
			room.departments.sort(function(a, b) {
			    var textA = a.deptName.toUpperCase();
			    var textB = b.deptName.toUpperCase();
			    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
			})
			room.departments.forEach((dept) => { 
				// Build up Concatenation of dept names
				label = label + dept.deptName + " / "
			})
			label = label.substr(label, label.length-3)
			// Add Label to the label array
			if (!state.legend.find((legendItem) => legendItem.label == label )) {  // Enforce Unique
				state.legend.push({ 'label': label })
			}				
		})

		// For each legend item, find matching rooms in floorRooms, summarize area, push into colorizeArray
		state.legend.forEach((legendItem) => {			
			// Find rooms that match each legenditem, put in rooms array
			let rooms = []

			// Alphabetize deptName
			state.floorRooms.forEach((room) => { 
				room.departments.sort(function(a, b) {
				    var textA = a.deptName.toUpperCase();
				    var textB = b.deptName.toUpperCase();
				    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
				})			

			// Concatenate Dept Names
			let label = ""
			room.departments.forEach((dept) => { label = label + dept.deptName + " / " })
			label = label.substr(label, label.length-3)
			
			if (label == legendItem.label) { rooms.push(room) }}) // Add matching room to array

			legendItem.rooms = rooms

			// Summarize Area for each legend item
			let area = 0			
			legendItem.rooms.forEach((room) => { area += room.area })
			legendItem.area = area
		})

		// Sort Array on Area
		state.legend.sort(function(a,b) {return b.area - a.area});		
			
		// Set Colors
		dispatch('setLegendItemColor')

		// Color Rooms
        dispatch('colorRooms')
	},

	async buildColorizedLegendArraybyPosition ({dispatch, state, rootState}) {
		// This particular one needs the full room return to get down to employees
		// Also this function combines the processLegend functions which I think is a better pattern
		let payload = { bldgAlpha: rootState.space.selectedBuilding.bldgAlpha, floor: rootState.ui.currentFloor }
		state.floorRooms = await dispatch('fetchBuildingRoomsFull', payload)
		console.log("Rooms: ", state.floorRooms)
		// For these rooms, determine unique Legend Items / values for chosen attribute. 
		state.legend = []
		state.floorRooms.forEach((room) => {
			room.PCT.forEach((PCT) => { 
				PCT.occupant.forEach((employee) => {
					// Add position descriptions for the employees in these rooms
					if (!state.legend.find((legendItem) => legendItem.label == employee.position ) &&
					     employee.position != null) {  // Enforce Unique
					    state.legend.push({ 'label': employee.position })
					}				
				})
			})
		})

		// For each legend item, find matching rooms in floorRooms, summarize area, push into colorizeArray
		state.legend.forEach((legendItem) => {
			
			// Find rooms that match each legenditem, put in rooms array
			let rooms = []
			state.floorRooms.forEach((room) => { 
				room.PCT.forEach((PCT) => { 
					PCT.occupant.forEach((employee) => {
						if (employee.position == legendItem.label) {
							rooms.push(room)
						}
					})
				})
			})
			legendItem.rooms = rooms

			// Summarize Area for each legend item
			let area = 0			
			legendItem.rooms.forEach((room) => { area += room.area })
			legendItem.area = area
		})

		// Sort Array on Area
		state.legend.sort(function(a,b) {return b.area - a.area});		
			
		// Set Colors
		dispatch('setLegendItemColor')

		// Color Rooms
        dispatch('colorRooms')
	},

	processLegend ({dispatch, state, rootState}) {
		// For each legend item, find matching rooms in floorRooms, summarize area, push into colorizeArray
		// Set colors
		
		// Summarize Area for this label
		state.legend.forEach((legendItem) => {
			
			// Filter rooms to summarize on deptName or userDeptName if this colorAttribute is "loaned"
			if (state.colorAttribute == "loaned") {
				legendItem.rooms = state.floorRooms.filter((room) =>  
					room.deptName === legendItem.label || room.userDeptName === legendItem.label
				)
			// Otherwise filter rooms to summarize based on state.colorAttribute
			} else {
				legendItem.rooms = state.floorRooms.filter((room) => room[state.colorAttribute] === legendItem.label)
			}			

			// Summarize Area for each legend item
			let area = 0			
			legendItem.rooms.forEach((room) => { area += room.area })
			legendItem.area = area
		})

		// Sort Array on Area
		state.legend.sort(function(a,b) {return b.area - a.area});		
			
		// Set Colors
		dispatch('setLegendItemColor')

		// Color Rooms
        dispatch('colorRooms')			
					
	},


	setLegendItemColor ({state, rootState}) { // Apply Color to each legend item
		
		let colorInterval = 0.0
		const interpolate = d3.interpolateHclLong("rgb(121, 0, 130)", "rgb(130, 88, 0)"); // Creates a spectrum purple,blue, green, yellow
		let spreadfactor = 1/state.legend.length // Space between each color in spectrum i think.

		// Iterate over legend
		state.legend.forEach((legendItem) => { 
			let colorCode = interpolate(colorInterval);		// get color from d3 spectrum defined above
			colorInterval += spreadfactor;					// increment to next colorInterval

			// These exceptions are colored grey
			if (legendItem.label == "Unassignable Space" || 
				legendItem.label == "Circulation Area" || 
				legendItem.label == "Circulation" || 
				legendItem.label == "Business Affairs General" || 
				legendItem.label == "Not Classified" || 
				legendItem.label == "None") {                        
                colorCode = "rgb(75 ,75 ,75)";
            }

            // Handling Nulls
            if (legendItem.label == null) {  
            	legendItem.label = "Not Evaluated"                      
                colorCode = "rgba(255 ,255 ,255, 0)";
            }

            // Shared is always this color
            if (legendItem.label == "Shared") { colorCode = "rgb(255, 30, 30)" }

            // Set color in array
            legendItem.color = colorCode

            // Dept Color from Archibus
            if (state.useDeptColors) {
	            let foundDept = rootState.lists.depts.find((dept) => { return dept.deptName == legendItem.label })
	            if (foundDept && foundDept.hexColor) { 
	            	let color = foundDept.hexColor.trim()
		            if (color.length==7) {
		            	//console.log(color, color.length)
		            	legendItem.color = `rgb(${hexRgb(color).red}, ${hexRgb(color).green}, ${hexRgb(color).blue})`
		            }
	        	}
        	}

        	// Dept Color from GIS 
/*            if (state.useDeptColors) {
	            let foundDept = rootState.ui.deptColors.find((dept) => { return dept.deptName == legendItem.label })
	            if (foundDept && foundDept.color) { 
		            	//console.log(color, color.length)
		            	legendItem.color = foundDept.color
		            }
        	}*/

            // Lookup any Custom Colors and override/replace
        	let fRow = state.colors.find((item) => { return item.legendLabel == legendItem.label })
        	if (fRow) {
        		//console.log("Found Custom Color", fow.color)
	            legendItem.color = `rgb(${hexRgb(fRow.color).red}, ${hexRgb(fRow.color).green}, ${hexRgb(fRow.color).blue})`
        	}        	
		})
	},

	// Fetch all room graphic features for current building, current floor from GIS service.
	// Loop through each legendItem's roomsArray
	// Find matching room graphic based on roomKey
	// Create symbol using legendItem.color
	// Instead of white, just use transparent
	// Add graphic to color layer.
	colorRooms ({state, getters, rootState}) {
		loadModules(["esri/map", "esri/layers/GraphicsLayer", "esri/symbols/SimpleLineSymbol", "esri/symbols/SimpleFillSymbol", "esri/symbols/PictureFillSymbol", "esri/Color", "esri/graphic",
					 "esri/tasks/query", "esri/tasks/QueryTask"])
                .then(([Map, GraphicsLayer, SimpleLineSymbol, SimpleFillSymbol, PictureFillSymbol, Color, Graphic, Query, QueryTask]) => {

			const colorLayer = rootState.mapFunctions.stateMap.getLayer("colorlayer")
			const esriToken	= jscookie.get(AUTH_COOKIE)

	        // Fetch all room features for current building.  
	        const queryTask = new QueryTask(rootState.user.viewRestricted ? getters.secureFloorURL[rootState.ui.currentFloor] + '?token='+esriToken : getters.floorURL[rootState.ui.currentFloor])
						        var query = new Query()
						        query.returnGeometry = true
						        query.outFields = ["*"]
						        query.where = "ROOMEXT.BldgAlpha = '" + rootState.space.selectedBuilding.bldgAlpha + "'" 

	        queryTask.on("complete", function (event) { 
	        	const graphics = event.featureSet.features;

	        	//console.log("Fetched Graphics", graphics)	        

				// Loop through each legendItem's roomsArray
				state.legend.forEach((legendItem) => {
					legendItem.rooms.forEach((room) => { 
						// Find matching room graphic based on roomKey
						const foundGraphic = graphics.find(graphic => {
							return graphic.attributes["ROOMEXT.roomKey"] === room.roomKey
						});

	                    if (foundGraphic) {   

	                        const addGraphic = new Graphic(foundGraphic.toJson()) // Copy the graphic, otherwise its a pointer  
	                        const colorVal = getColor(legendItem.color) // Adds Transparency
	                        let symbol = new SimpleFillSymbol("solid", 
	                        	new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID, new Color(colorVal), 3), new Color(colorVal))

	                        // Skip the coloring if its white.
							if (legendItem.color != 'rgb(255, 255, 255)') {
								
								// Set Symbol and Add Graphic
	                        	addGraphic.setSymbol(symbol)
	                        	colorLayer.add(addGraphic);
							}
						}

						// If the room is borrowed and we are viewing classification, add an outline
						if (foundGraphic && state.hatchClassOn && room.userDeptName) {							
							
							// Set Symbol and Add Graphic
							const outlineGraphic = new Graphic(foundGraphic.toJson()) // Copy the graphic, otherwise its a pointer 
							const outlineSymbol = new SimpleFillSymbol("solid", 
                    							new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID, new Color([235,0,0]), 3), new Color([255,255,255,0]))
							outlineGraphic.setSymbol(outlineSymbol)
	              			colorLayer.add(outlineGraphic);		
						}

						// Hatch for each kind of classification
						if (foundGraphic && state.hatchClassOn) {
							const cGraphic = new Graphic(foundGraphic.toJson()) // Copy the graphic, otherwise its a pointer 
							const cSymbol = new PictureFillSymbol();

	                    	if (room.classification == "Research") {
								cSymbol.setOffset(0, 0);
								cSymbol.setYScale(2);
								cSymbol.setXScale(2);
								cSymbol.setUrl("https://interactivefloorplans.arizona.edu/static/img/diamond-pattern.png");
								cGraphic.setSymbol(cSymbol)
	                        	colorLayer.add(cGraphic);
	                        }

	                        if (room.classification == "Education") {
								cSymbol.setOffset(0, 0);
								cSymbol.setYScale(.7);
								cSymbol.setXScale(.7);
								cSymbol.setHeight(43);
								cSymbol.setWidth(40);
								cSymbol.setUrl("https://interactivefloorplans.arizona.edu/static/img/triangle-pattern.png");
								cGraphic.setSymbol(cSymbol)
	                        	colorLayer.add(cGraphic);
	                        }

	                        // This is not a classification type.  Not sure how this will work.
/*	                        if (room.classification == "Faculty Office") {                    		
								cSymbol.setOffset(0, 0);
								cSymbol.setYScale(2);
								cSymbol.setXScale(2);
								//symbol.setHeight(43);
								//symbol.setWidth(40);
								cSymbol.setUrl("https://interactivefloorplans.arizona.edu/static/img/box-pattern.png");
								cGraphic.setSymbol(cSymbol)
	                        	colorLayer.add(cGraphic);
	                        }  */

	                        if (room.classification == "Administration") {                    		
								cSymbol.setOffset(0, 0);
								cSymbol.setYScale(1);
								cSymbol.setXScale(1);
								cSymbol.setHeight(25);
								cSymbol.setWidth(25);
								cSymbol.setUrl("https://interactivefloorplans.arizona.edu/static/img/dot-pattern.png");
								cGraphic.setSymbol(cSymbol)
	                        	colorLayer.add(cGraphic);
	                        }  

	                        // Patient care was as solid white box
	                    }
							
	                })
				})
			})

			queryTask.execute(query)

			function getColor(color) {
				const colorValue = color.replace(/[rgb()\s]/g, '')
	            const colorVal = colorValue.split(",")
	            colorVal.push(0.45)	//  Transparency
				return colorVal
			}

		})
	},	

	resetColorize ({state, rootState}) {
		//console.log("ResetColorize")
		state.legend = []
		state.colorDomain = null
		state.colorAttribute = null
		rootState.mapFunctions.clearGraphics('colorlayer')
	},
}

export default {
	state,
	actions,
	mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/colorRooms.js